import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const apiUrl = `${baseApiUrl}/api/resignationreason`;

export async function getResignationReasons() {
    return await httpRequest(fetchResignationReasons.bind(this));
}

async function fetchResignationReasons() {
    let config = getHttpHeaders();
    return await axios.get(`${apiUrl}`, config);
}
